import React, { createContext, useContext } from 'react'
import { useRouteMatch, useLocation } from '@fs/zion-router'
import { useQuery } from '@apollo/client'
import api from '../api/brightspot'

export const SpeakerContext = createContext()
export const useCurrentSpeaker = () => useContext(SpeakerContext)

export function SpeakerProvider({ children }) {
  const routeMatch = useRouteMatch('/speakers/:id/:lan')
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const previewId = params.get('previewId')
  const pathOrId = previewId || routeMatch?.url
  const query = useQuery(api.speaker.speakerGQLQuery(pathOrId), {
    // Don't request the data if we don't have a preview id, or a speaker path
    skip: !previewId && !routeMatch?.params.id,
  })

  return <SpeakerContext.Provider value={query}>{children}</SpeakerContext.Provider>
}
